export function sanitizeForm<T>(form: T): T {
  const cleanedForm = { ...form };
  for (const key in cleanedForm) {
    const value = cleanedForm[key as keyof T];
    if (typeof value === 'string' && value.trim() === '') {
      (cleanedForm as any)[key] = undefined;
    }
  }
  return cleanedForm;
}
